import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {


  url = environment.serverAPI4 + "/api/adminNotification";

  constructor(private http: HttpClient) { }

  getAllNotification(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllNotificationNew(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/new?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllMentionsNotification(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/mention?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllNotificationDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getNotificationById(notificationId: number): Observable<Object> {
    return this.http.get(`${this.url}/${notificationId}`);
  }

  addOrEditNotification(Notification: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, Notification);
  }

  searchAdminNotification(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  searchNotification(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  searchNotificationAdvance(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/filter/advanced${queryParams}`, requestBody);
  }

}
